import { memo } from 'react';
import { errToast, succToast, ValidateEmail } from '@/utils.js';
import ForgetPassForm from './forms/forgetPassForm';
import { ForgetPassword } from '@/api/endpoints';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const ForgetPass = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()
    const forgetPassword = (e, data) => {
        e?.preventDefault()
        console.log(data)

        if (!ValidateEmail(data.email?.value)) return errToast(t("email-not-valid"))

        data.setLoading(true)
        ForgetPassword({email :data.email?.value}).then(res => {
            succToast(t("Code is sent to your email"))
            navigate('/auth/verify-code', { state: { email: data.email?.value } })
        }).catch(() => {
            errToast(t("failed to send code"))
        }).finally(_ => {
            data.setLoading(false)
        })
    }

    return (
        <ForgetPassForm onSubmit={forgetPassword} />

    );
}

export default memo(ForgetPass);

